import React, { useMemo } from "react"
import { isEmpty } from "lodash"
import { useMobileRecordsContext } from "../../contexts/mobileRecordsContext"
import MobileRecordRow from "./mobileRecordRow"
import { useParams } from "react-router-dom"
import { alphaNumCompare } from "../../utilities/utils"

const RenderRow = () => {
  const { projectId } = useParams()
  const { mobileRecords, tabNames } = useMobileRecordsContext()

  const mobileRecordTabs = useMemo(() => {
    const rootRecordArray = mobileRecords?.root?.map(record => {
      return {
        mobileRecordRoute: `/projects/${projectId}/notes/${record?.id}`,
        title: record?.title || record?.record_type?.replaceAll(/_/g, " "),
        urlParam: record?.id,
      }
    }) || []

    const tabNameArray = tabNames?.map(tabName => {
      return {
        mobileRecordRoute: `/projects/${projectId}/notes?tab=${tabName}`,
        title: tabName,
        urlParam: tabName,
      }
    }) || []

    return rootRecordArray.concat(tabNameArray).sort((a, b) => alphaNumCompare(a.title, b.title))
  }, [mobileRecords, tabNames])


  return (
    <div className="flex overflow-x-scroll flex-row min-h-10">
      {!isEmpty(mobileRecordTabs) && mobileRecordTabs.map(mobileRecordTab => (
        <MobileRecordRow key={mobileRecordTab.title} title={mobileRecordTab.title}
                         mobileRecordRoute={mobileRecordTab.mobileRecordRoute} urlParam={mobileRecordTab.urlParam} />
      ))}
    </div>
  )
}

export default RenderRow
